/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import * as _ from 'lodash';
import Styled from './ViewLocation.style';
import {
  Wrap,
  Button,
  Avatar,
  Popup,
  Icon,
  BackButton,
  NothingToDisplay,
  Typography,
  Loader,
} from '../../components/index';
import { CounterControl } from '../../components/index';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useParams, useNavigate } from 'react-router-dom';
import { useResponsivity } from '../../helpers/helpers';
import { useTranslation } from 'react-i18next';
import { getOptionLabel } from '../AddRoom/getOptionLabel';
import { washroomConfig } from '../AddRoom/Washroom/washroomJson';
import { kitchenConfig } from '../AddRoom/Kitchen/kitchenJson';

interface ViewLocationProps {
  listLocation: any;
  room: any;
  deleteRoom: Function;
  listLocations: Function;
  updateRoomUsage: Function;
}

const ViewLocation: React.FC<ViewLocationProps> = (props) => {
  const { listLocation, room, deleteRoom, listLocations, updateRoomUsage } =
    props;
  const { locationId } = useParams();
  const [expandedRoom, setExpandedRoom] = React.useState<string | null>(null);
  const [actions, setActions] = React.useState<
    Record<
      string,
      {
        leaksFixed: string[];
        postersFitted: string[];
        tapInsertsFitted: number;
      }
    >
  >({});
  const [isId, setId] = React.useState();
  const [popup, setPopup] = React.useState(false);
  const data = _.get(listLocation, 'data.data');
  const isMobile = useResponsivity();
  const navigate = useNavigate();
  const { error, loading, done } = _.get(listLocation, 'status');
  const [t] = useTranslation('common');
  const findElement = _.find(data, function (o) {
    return o.id == locationId;
  });
  const getRooms = _.get(findElement, 'rooms');
  const roomLength = _.get(getRooms, 'length');

  const sadFace = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M9 9H9.01M15 9H15.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#ED1C25"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const happyFace = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M9 9H9.01M15 9H15.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#4BAE50"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const toggleRoom = (roomId: string) => {
    setExpandedRoom((current) => (current === roomId ? null : roomId));
  };

  React.useEffect(() => {
    listLocations();
  }, [listLocations]);

  const renderNoRooms = () => {
    return (
      <Col md={12} sm={12} xs={12}>
        <NothingToDisplay
          title="You have no room(s) added for this location."
          location={`/${locationId}/add-room`}
          subtitle="Please add a room in order to view your data."
          buttonText="Add room(s)"
        />
      </Col>
    );
  };
  const toggleLeakFixed = (roomId: string, applianceId: string) => {
    setActions((prev) => {
      const current = prev[roomId] ?? {
        leaksFixed: [],
        postersFitted: [],
        tapInsertsFitted: 0,
      };

      const exists = current.leaksFixed.includes(applianceId);

      return {
        ...prev,
        [roomId]: {
          ...current,
          leaksFixed: exists
            ? current.leaksFixed.filter((id) => id !== applianceId)
            : [...current.leaksFixed, applianceId],
        },
      };
    });
  };

  const togglePoster = (roomId: string, poster: string) => {
    setActions((prev) => {
      const current = prev[roomId] ?? {
        leaksFixed: [],
        postersFitted: [],
        tapInsertsFitted: 0,
      };

      const exists = current.postersFitted.includes(poster);

      return {
        ...prev,
        [roomId]: {
          ...current,
          postersFitted: exists
            ? current.postersFitted.filter((p) => p !== poster)
            : [...current.postersFitted, poster],
        },
      };
    });
  };

  const updateTapInserts = (roomId: string, value: number) => {
    setActions((prev) => ({
      ...prev,
      [roomId]: {
        ...(prev[roomId] ?? {
          leaksFixed: [],
          postersFitted: [],
        }),
        tapInsertsFitted: value,
      },
    }));
  };
  const renderApplianceCards = (room: any) => {
    const groups =
      room.type === 'kitchen'
        ? [
            {
              title: 'Kitchen taps',
              data: room.data?.taps,
              fields: [
                { key: 'type', label: 'Type' },
                { key: 'flowrate', label: 'Flow rate' },
                { key: 'leak', label: 'Leak' },
              ],
            },
          ]
        : [
            {
              title: 'Taps',
              data: room.data?.taps,
              fields: [
                { key: 'type', label: 'Type' },
                { key: 'flowrate', label: 'Flow rate' },
                { key: 'leak', label: 'Leak' },
              ],
            },
            {
              title: 'Showers',
              data: room.data?.showers,
              fields: [
                { key: 'type', label: 'Type' },
                { key: 'control', label: 'Control' },
                { key: 'leak', label: 'Leak' },
              ],
            },
            {
              title: 'Toilets',
              data: room.data?.toilets,
              fields: [
                { key: 'type', label: 'Type' },
                { key: 'leak', label: 'Leak' },
              ],
            },
            {
              title: 'Urinals',
              data: room.data?.urinals,
              fields: [
                { key: 'type', label: 'Type' },
                { key: 'leak', label: 'Leak' },
              ],
            },
          ];

    return (
      <>
        {groups.map((group) => {
          if (!group.data || Object.keys(group.data).length === 0) return null;

          return (
            <div key={group.title} style={{ marginBottom: 32 }}>
              <Typography
                size="3"
                text={group.title}
                style={{ marginBottom: 16 }}
              />
              <Row>
                {Object.entries(group.data).map(([key, appliance]: any) => {
                  const applianceNumber = Number(key.split('_')[1]) + 1;
                  const hasLeak = !!appliance.leak;

                  const leakFixed =
                    actions[room.id]?.leaksFixed.includes(key) ?? false;

                  const showHappyFace = !hasLeak || leakFixed;
                  const applianceName =
                    {
                      Taps: 'Tap',
                      Showers: 'Shower',
                      Toilets: 'Toilet',
                      Urinals: 'Urinal',
                      'Kitchen taps': 'Tap',
                    }[group.title] ?? 'Appliance';
                  return (
                    <Col md={4} sm={6} xs={12} key={key}>
                      <Styled.SummaryItem
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'stretch',
                          marginBottom: 16,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography
                            size="p"
                            text={`${applianceName} ${applianceNumber}`}
                            style={{ fontWeight: 600 }}
                          />
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {showHappyFace ? happyFace : sadFace}

                            <span
                              style={{
                                marginLeft: '8px',
                                fontWeight: 500,
                                color: showHappyFace ? '#4BAE50' : '#ED1C25',
                              }}
                            >
                              {showHappyFace ? 'Done' : 'Needs attention'}
                            </span>
                          </div>
                        </div>
                        {group.fields.map((field) =>
                          appliance[field.key] ? (
                            <Typography
                              key={field.key}
                              size="p"
                              style={{ fontSize: '14px', color: '#7a7a7a' }}
                              text={`${field.label}: ${t(
                                getOptionLabel(
                                  room.type === 'washroom'
                                    ? washroomConfig
                                    : kitchenConfig,
                                  appliance[field.key],
                                ),
                              )}`}
                            />
                          ) : null,
                        )}

                        {appliance.leak && (
                          <Styled.ToggleRow>
                            <Typography size="p" text="Leak fixed?" />

                            <Styled.Toggle
                              checked={
                                actions[room.id]?.leaksFixed.includes(key) ??
                                false
                              }
                              onClick={() => toggleLeakFixed(room.id, key)}
                            />
                          </Styled.ToggleRow>
                        )}
                      </Styled.SummaryItem>
                    </Col>
                  );
                })}
              </Row>
            </div>
          );
        })}
      </>
    );
  };
  const renderSiteChecklist = (room: any) => (
    <>
      <Typography size="3" text="Posters" style={{ marginBottom: 16 }} />
      <Row>
        {[
          { key: 'bathroom', title: 'Bathroom poster' },
          { key: 'kitchen', title: 'Kitchen poster' },
          { key: 'leaks', title: 'Leak poster' },
          { key: 'water-saving', title: 'Water saving poster' },
        ].map((poster) => {
          const isDone =
            actions[room.id]?.postersFitted.includes(poster.key) ?? false;

          return (
            <Col md={4} sm={6} xs={12} key={poster.key}>
              <Styled.SummaryItem>
                <div style={{ width: '100%' }}>
                  <div
                    style={{
                      display: 'flex',

                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography
                      size="p"
                      text={poster.title}
                      style={{ fontWeight: 600, margin: 0, padding: 0 }}
                    />

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {isDone ? happyFace : sadFace}

                      <span
                        style={{
                          marginLeft: 8,
                          fontWeight: 500,
                          color: isDone ? '#4BAE50' : '#ED1C25',
                        }}
                      >
                        {isDone ? 'Done' : 'Needs attention'}
                      </span>
                    </div>
                  </div>

                  <Styled.ToggleRow>
                    <Typography size="p" text="Displayed?" />

                    <Styled.Toggle
                      checked={isDone}
                      onClick={() => togglePoster(room.id, poster.key)}
                    />
                  </Styled.ToggleRow>
                </div>
              </Styled.SummaryItem>
            </Col>
          );
        })}
      </Row>

      <Typography
        size="3"
        text="Tap inserts"
        style={{ marginTop: 32, marginBottom: 16 }}
      />

      <Row>
        <Col md={4} sm={6} xs={12}>
          <Styled.SummaryItem>
            <Typography
              size="p"
              text="Tap inserts fitted"
              style={{ fontWeight: 600 }}
            />

            <div style={{ marginTop: 16 }}>
              <CounterControl
                answerKey="tap_inserts"
                label=""
                value={actions[room.id]?.tapInsertsFitted ?? 0}
                min={0}
                max={100}
                defaultValue="0"
                updateAnswerKey={(_, value) =>
                  updateTapInserts(room.id, Number(value))
                }
              />
            </div>
          </Styled.SummaryItem>
        </Col>
      </Row>
    </>
  );
  const renderRooms = () => {
    return _.map(getRooms, (el, index) => {
      return (
        <Col
          md={12}
          sm={12}
          xs={12}
          key={index}
          style={{
            marginBottom: '16px',
          }}
        >
          <Styled.Box open={expandedRoom === el.id}>
            <div
              className="top"
              onClick={() => toggleRoom(el.id)}
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                }}
              >
                <Avatar style={{ width: '38px', height: '38px' }}>
                  {index + 1}
                </Avatar>

                <div className="title" style={{ marginLeft: '12px' }}>
                  <div>{el.name || 'Sample room title'}</div>
                  <div>{el.type}</div>
                </div>
              </div>
              <div className="bottom">
                <Button
                  onClick={() => {
                    navigate(`/${locationId}/edit-room/${el.id}`);
                  }}
                  style={{ marginRight: '16px' }}
                  appearance="OUTLINED"
                >
                  <Icon icon="pen" size={20} style={{ marginRight: '8px' }} />{' '}
                  Edit
                </Button>

                <Button
                  onClick={() => {
                    setPopup(!popup);
                    setId(el.id);
                  }}
                  appearance="OUTLINED"
                >
                  <Icon icon="trash" size={20} style={{ marginRight: '8px' }} />{' '}
                  Delete
                </Button>
              </div>
              <Icon
                icon={expandedRoom === el.id ? 'chevronUp' : 'chevronDown'}
                size={20}
                style={{
                  transform:
                    expandedRoom === el.id ? 'rotate(-180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease',
                }}
              />
            </div>

            <Styled.AccordionContent open={expandedRoom === el.id}>
              {renderApplianceCards(el)}

              {renderSiteChecklist(el)}

              <Styled.SubmitButtonWrap>
                <Button
                  onClick={() => {
                    const payload = {
                      'leaks-fixed': actions[el.id]?.leaksFixed ?? [],

                      'tap-inserts-fitted':
                        actions[el.id]?.tapInsertsFitted ?? 0,

                      'posters-fitted': actions[el.id]?.postersFitted ?? [],
                    };

                    console.log(payload);

                    updateRoomUsage(el.id, payload);
                  }}
                >
                  Save Progress
                </Button>
              </Styled.SubmitButtonWrap>
            </Styled.AccordionContent>
          </Styled.Box>
        </Col>
      );
    });
  };

  const renderPage = () => {
    if (roomLength === 0) {
      return renderNoRooms();
    } else {
      return renderRooms();
    }
  };

  return (
    <Wrap>
      <Row>
        <Col md={12} sm={12} xs={12}>
          <Typography
            size="1"
            text="My rooms"
            style={{ marginBottom: '16px' }}
          />
        </Col>
        <Col md={12} sm={12} xs={12} style={{ marginBottom: '32px' }}>
          <Styled.TopBtnWrap>
            <BackButton />
            {roomLength === 0 ? null : (
              <Button onClick={() => navigate(`/${locationId}/add-room`)}>
                Add new room
              </Button>
            )}
          </Styled.TopBtnWrap>
        </Col>
      </Row>
      <Row>
        {loading && !done ? <Loader /> : renderPage()}
        <Popup
          open={popup}
          isDesktop={!isMobile}
          handleClick={() => {
            setPopup(!popup);
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <Typography
              size="3"
              text="Are you sure you want to delete your room?"
            />
            <Typography size="p" text="All your data will be lost" />
            <Styled.ButtonWrap>
              <Button
                className="delete-yes"
                onClick={() => {
                  deleteRoom(isId);
                  setPopup(!popup);
                  setTimeout(() => {
                    listLocations();
                  }, 500);
                }}
              >
                Yes
              </Button>{' '}
              <Button
                onClick={() => {
                  setPopup(!popup);
                }}
              >
                No
              </Button>
            </Styled.ButtonWrap>
          </div>
        </Popup>
      </Row>
    </Wrap>
  );
};

export default ViewLocation;
